import { Box, VStack, HStack, Badge, Progress, Card, CardBody } from "@chakra-ui/react";
import CDS from "design-system";
import { getOnboardingPeriodDisplay } from "features/NewHireJourney/helpers";

interface WelcomeCardProps {
  newHireName: string;
  stage: string;
  startDate: string;
  daysCompleted: number;
}

export default function WelcomeCard({ newHireName, stage, startDate, daysCompleted }: WelcomeCardProps) {
  const { timeLabel, progressLabel, progress } = getOnboardingPeriodDisplay(daysCompleted);

  return (
    <Card bg="transparent" shadow="none" border="1px solid" borderColor="gray.200">
      <CardBody>
        <VStack align="stretch" spacing={4}>
          <Box>
            <CDS.Text18 fontSize="2xl" fontWeight="semibold" color="content.primary">
              Welcome, {newHireName}! 👋
            </CDS.Text18>
            <CDS.Text14 color="content.tertiary" mt={1}>
              You started on {startDate}
            </CDS.Text14>
          </Box>

          <HStack spacing={3}>
            <Badge bg="newHireGreen.bg" color="newHireGreen.text" px={3} py={1} borderRadius="md">
              {stage}
            </Badge>
            <CDS.Text12 color="content.tertiary">
              {timeLabel}
            </CDS.Text12>
          </HStack>

          <Box>
            <HStack justify="space-between" mb={2}>
              <CDS.Text12 fontWeight="medium" color="content.primary">
                {progressLabel}
              </CDS.Text12>
              <CDS.Text12 fontWeight="semibold" color="brand.500">
                {progress}%
              </CDS.Text12>
            </HStack>
            <Progress
              value={progress}
              colorScheme="blue"
              borderRadius="full"
              bg="gray.200"
              sx={{
                "& > div": {
                  bg: "brand.500",
                },
              }}
            />
          </Box>
        </VStack>
      </CardBody>
    </Card>
  );
}
